import type { PathAnalyticPageSelectFragment } from '~/api/graphql/fragments/pathAnalytic.generated';
import type { IPathAnalysisFirstLevel } from '../contexts';

import { useMemo } from 'react';

interface IUsePathAnalysisFunnelProps {
  pathAnalytics: PathAnalyticPageSelectFragment[];
  dataFirstLevels?: IPathAnalysisFirstLevel[];
}
export const usePathAnalyticsMerger = ({
  pathAnalytics,
  dataFirstLevels,
}: IUsePathAnalysisFunnelProps) => {
  const { firstLevelData, otherLevelsData } = useMemo(() => {
    return pathAnalytics.reduce(
      (acc, item) => {
        if (item.level === 1) {
          acc.firstLevelData[item.locationPath ?? ''] = item;
        } else {
          acc.otherLevelsData.push(item);
        }
        return acc;
      },
      {
        firstLevelData: {} as Record<string, PathAnalyticPageSelectFragment>,
        otherLevelsData: [] as PathAnalyticPageSelectFragment[],
      },
    );
  }, [pathAnalytics]);

  const processedPathAnalytics = useMemo(() => {
    if (!dataFirstLevels) return pathAnalytics;

    const mergedFirstLevels: PathAnalyticPageSelectFragment[] = dataFirstLevels.map((item) => {
      const firstLevelDataItem = firstLevelData[item.locationPath];
      if (!firstLevelDataItem) {
        return item as PathAnalyticPageSelectFragment;
      }

      return firstLevelDataItem;
    });
    return [...mergedFirstLevels, ...otherLevelsData];
  }, [pathAnalytics, dataFirstLevels, firstLevelData, otherLevelsData]);

  return { processedPathAnalytics };
};
